module.exports = __webpack_public_path__ + "img/icon-stakewise-red.b061391f.svg";